import { render, staticRenderFns } from "./vouchers.vue?vue&type=template&id=50191e60&scoped=true&"
import script from "./vouchers.vue?vue&type=script&lang=js&"
export * from "./vouchers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50191e60",
  null
  
)

export default component.exports